const indexItems = [
  { icon: 'ri-fire-line', title: '热门动作片', desc: '燃爆肾上腺的硬核动作大片合集', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-emotion-laugh-line', title: '高分喜剧', desc: '笑到停不下来的口碑喜剧精选', color: 'bg-accent-100 text-accent-800' },
  { icon: 'ri-rocket-line', title: '科幻巨制', desc: '脑洞大开的视觉盛宴科幻片', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-lightbulb-flash-line', title: '悬疑烧脑', desc: '环环相扣的高能反转悬疑佳作', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-vidicon-line', title: '经典老片', desc: '时光沉淀的永恒银幕经典', color: 'bg-accent-100 text-accent-800' },
  { icon: 'ri-ghost-smile-line', title: '动画精选', desc: '全家共享的优质动画电影', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-movie-line', title: '纪录佳作', desc: '真实震撼的高分纪录片推荐', color: 'bg-primary-100 text-primary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">精彩专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">按类型探索海量电影资源，找到你的下一部心头好</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <span className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${item.color} mb-3 transition-transform group-hover:scale-110`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">{item.title}</span>
              <span className="text-xs text-foreground-500 text-center mt-1 leading-tight">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}